<template>
  <el-dialog
    title="选择菜单"
    :visible="visible"
    width="50%"
    @open="handleOpen"
    @close="handleClose"
    append-to-body
    destroy-on-close
  >
    <div style="height: 300px; overflow-y: auto">
      <el-tree
        highlight-current
        :data="data"
        :props="defaultProp"
        :default-expand-all="true"
        @node-click="handleNodeClick"
      ></el-tree>
    </div>
    <div slot="footer">
      <el-button type="primary" size="small" @click="handleConfirm"
        >确定</el-button
      >
      <el-button size="small" @click="handleClose">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { selectMenu } from "@/api/system/menu";
import { toTree } from "@/utils";

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      data: [],
      selectNode: null,
      defaultProp: {
        label: "name",
        children: "children",
      },
    };
  },
  methods: {
    getMenu() {
      selectMenu().then((data) => {
        this.data = toTree(data, -1);
      });
    },
    handleNodeClick(data) {
      this.selectNode = data;
    },
    handleConfirm() {
      if (this.selectNode) {
        this.$emit("confirm", this.selectNode);
        this.handleClose();
      } else {
        this.$message({
          type: "warning",
          message: "请选择节点",
        });
      }
    },
    handleOpen() {
      this.getMenu();
    },
    handleClose() {
      this.$emit("update:visible", false);
    },
  },
};
</script>







// WEBPACK FOOTER //
// src/views/system/menu/add-edit/menu.vue